export default __webpack_public_path__ + "static/lenta_onlain-a9bdb6cc7d9d2840af3e349d330ea678.png";